module.exports = __webpack_public_path__ + "static/media/video2.389f6f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/video/video2.mp4
// module id = +YF6
// module chunks = 0